import { HttpInterceptorFn } from '@angular/common/http';
import { catchError, mergeMap, throwError } from 'rxjs';
import { AuthService, StorageService } from '@app/core/services';
import { inject } from '@angular/core';

export const autoLoginInterceptor: HttpInterceptorFn = (req, next) => {
  const authService: AuthService = inject(AuthService);
  const storageService: StorageService = inject(StorageService);
  return next(req).pipe(
    catchError((err) => {
      if (err.status === 401 || err.status === 403) {
        return authService.autoLogin().pipe(
          mergeMap(() => {
            const token = storageService.token;
            const authReq = req.clone({
              setHeaders: { Authorization: `Bearer ${token}` }
            });
            return next(authReq);
          })
        );
      }
      return next(req);
    }),
  );
};
